module.exports = __webpack_public_path__ + "img/platform_2_mobile.9dd1d8f.jpg";